module.exports = __webpack_public_path__ + "img/money-up@3x.c0ec30d0.png";